/* RESPONSIBLE TEAM: team-workflows */
import type HandoffToSalesforceTeam from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-team';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToSalesforceTeamConfiguration extends StepConfig {
  declare step: HandoffToSalesforceTeam;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-salesforce-team',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
